import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'Fires when a credit consumption warning banner or popover is shown to the user (impression, not interaction). Depleted-state impressions are tracked separately via depleted_state_viewed.',
  name: 'credit_warning_popover_shown',
  params: [
    {
      description: 'The type of warning UI that was shown',
      name: 'type',
      required: true,
      type: 'enum',
      values: ['popover', 'banner'],
    },
    {
      description: 'Subscription plan name',
      name: 'plan',
      required: true,
      type: 'string',
    },
    {
      description: 'Credit pack quantity currently on the subscription',
      name: 'existing_pack_quantity',
      required: true,
      type: 'number',
    },
    {
      description: 'Whether a credit pack change is already queued on the subscription',
      name: 'credit_pack_change_pending',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Number of credits remaining in the current cycle',
      name: 'credits_remaining',
      required: true,
      type: 'number',
    },
    {
      description: 'Percentage of credits used',
      name: 'pct_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of credits used in the current cycle',
      name: 'credits_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of days since the billing cycle started',
      name: 'days_since_cycle_start',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
